/* eslint-disable no-unused-vars */
/* global G */
import { curry } from 'lib/util'

/**
 * Update Event Handler
 *
 * Initializes an UI update. Enables or disables transition animations
 * based on `transition`.
 *
 * @param {Gaia.AppModule.Spec} module      the current module composition object
 * @param {Gaia.Component.Spec} component   the current action's main component
 * @param {Gaia.PlatformEvent} event        the event object that triggered this handler
 * @returns {Promise<void>}
 */
const update = async (module, component, event) => {
  await module[G.ADAPTER][G.UI].update(module)
}

export default curry(update)
